import React from 'react'
import { Link } from "react-router-dom";
import error from './images/error.png'

function Error404() {
  return (
    // <div className='w-screen h-screen flex justify-center items-center'>
    //     <img className='w-1/2' src={error} />
    // </div>
    <div className="flex flex-col items-center justify-center h-screen">
      <img className='w-1/2' src={error} />
      <Link to="/" className="px-4 py-2 bg-[#5b5b5b] text-white rounded-md hover:bg-[#424242]">
        Go Back Home
      </Link>
    </div>
  )
}

export default Error404 